module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av731-8ad96033c08279f8a1c69bc0bdfb2ca4.jpg";